import mdsRequire from 'dojo/require';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './SelectEntityDialog.html?raw';
import on from 'dojo/on';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import GenericDialog from '../GenericDialog/GenericDialog';
import "../GenericDialog/GenericDialog";
import aspect from 'dojo/aspect';
import { SelectEntityDialogTypes, SelectEntityDialogTypes as Types } from "../../_loadingHelpers/SelectEntityDialog";
import { FilterPanelTypes, FilterPanelFormat, FilterOptionTypes, FilterPanelWidget } from "../../../moreCore/_loadingHelpers/Filterpanel";
import { EntityHelpers, HtmlHelpers } from "../../../more/Helpers";
import SelectEntityDialogPreview from './SelectEntityDialogPreview';

import "../../UI/FilterPanel/FilterPanel";

class SelectEntityDialog<T> extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private mainContainer: HTMLElement;
    private hiddenContainer: HTMLElement;
    private treeDescriptionContainer: HTMLElement;
    private treeDescription: HTMLElement;
    private treeTabContainer: HTMLElement;
    private selectionTabContainer: HTMLElement;
    private bottomContainer: HTMLElement;
    private progressContainer: HTMLElement;
    private paginationContainer: HTMLElement;
    private resultContainer: HTMLElement;
    private itemContainer: HTMLElement;
    private searchInput: HTMLInputElement;
    private noResultContainer: HTMLElement;
    private previewSection: HTMLElement;
    private txtPreviewSelectionHeading: HTMLElement;
    private previewContentNode: HTMLElement;
    private resultInfoContainer: HTMLElement;
    private selectedItemsLabel: HTMLElement;
    private filterContainer: HTMLElement;
    private filterPanelContainer: HTMLElement;
    private btnShowSelection: HTMLButtonElement;
    private rulesLabelContainer: HTMLElement;
    private rulesLabel: HTMLElement;
    private rulesWarningIconContainer: HTMLElement;

    private rules: Types.DlgRule;
    //searchContainerNode: HTMLElement;
    //resultlist: HTMLElement;
    private _requestParameterName: string = "jsonData";

    private resultlist: {
        _tableNode: null,
        _tableBodyNode: null,
        startIndex: 0,
    };

    private dlg: MdsLax<InstanceType<typeof GenericDialog>> = null;
    private callback: Function = null;
    private dlgTitle: string = "unnamed dialog";

    private isPagingEnabled: boolean = true; // Hinweis: false ist noch nicht vorgesehen.

    readonly result: any = null;
    private _isRequestActive: boolean = false;
    //private _lastResponse: more.PackedEntitylistResult<any>;

    //showSelectedTab: boolean = false;
    private _enableMultiselect: boolean = false;
    private _enableSelectAll: boolean = false;
    closeOnSelect: boolean = false;
    allowEmptyValue: boolean = false;
    private createNewCallback: Function = null;
    showDetailsCallback: Function = null;
    emptyValueOnClose: boolean = true;
    requestUrlOrFunction: string = "?";

    private showNewEntryTab: boolean = false;
    private _showSelected: boolean = false;
    private selectionTabEnabled: boolean = false;
    private _selectedTree: Types.Tree<T> = { // leerer (unsichtbarer) Standardbaum
        name: "",
        label: "",
        selectorNode: null,
        ruleLabelNode: null,
        rules: null,
        iconNode: null,
        searchPrompt: (this as any).translate("SelectEntityDlg__SearchPromptDefault"),
        _loadedSearchValue: "%",
        _lastRequestResponse: null,
        _requestParams: null,
        requestUrlOrFunction: null,
        additionalData: null
    };

    private _searchValue: string = null;
    //private _loadedPage: SelectEntityDlgResultPage = null;
    //private _displayedPage: SelectEntityDlgResultPage = null;
    private _targetPageNumber: number = 1;
    private _displayedPageNumber: number = -1;

    labelAttribute: string = null;
    secondaryLabelAttribute: string = null;
    valueAttribute: string = "ID";
    colorationAttribute: string = null;

    private _entriesPerPage: number = 15;
    private selectedItems: Array<Types.Item<T>> = [];
    private availableItems: Array<Types.Item<T>> = [];
    private targetValues: Array<any> = [];
    //private valueProperty: string = "ID";
    //private labelProperty: string = "ID";
    //private secondaryLabelProperty: string = null;
    //private searchProperty: string = "ID";

    private pagingInfoFormatstring: string = (this as any).translate("SelectEntityDlg__ResultInfoFormatstring");


    private trees: Array<Types.Tree<T>> = [];
    /**
     *
     * @param config Konfigurationspaket SelectEntityDlgConfiguration (aus Backend)
     * @param callbackFct Wird bei Bestätigung oder Abbruch des Dialogs ausgegeben. Aufruf der Callback-Fkt mit einem Array von Werten und einem Array der Items
     */
    setConfiguration(config: Types.DlgConfiguration<T>, callbackFct: (values: Array<string>, items: Array<SelectEntityDialogTypes.Item<T>>) => any, newButtonCallbackFct?: Function) {

        if (config.trees && config.initialSelectedTree) {
            for (let tree of config.trees) {
                if (tree.name == config.initialSelectedTree) {
                    tree._initialSelected = true;
                    break;
                }
            }
        }

        this.setup(config.title,
            callbackFct,
            config.callfunction ? config.callfunction : config.requestUrl,
            config.entriesPerPage,
            config.trees,
            config.rules,
            config.labelAttribute,
            config.valueAttribute,
            config.secondaryLabelAttribute,
            config.enableSelectAll
            //config.initialResultList
        );

        //if (config.entries) {
        //    //this.addEntry
        //}

        this.createNewCallback = newButtonCallbackFct;

    }

    private _globalRequestProperties: Object = null;
    /**
     * Fügt eine Name-Value-Paar für die Suchrequests hinzu (unabhängig von gewählten oder vorhandenen Tress)
     * @param name Name des Properties im Request
     * @param value Wert des Properties im Request
     */
    addGlobalRequestProperty(name: string, value: any) {
        if (!this._globalRequestProperties) {
            this._globalRequestProperties = {};
        }

        this._globalRequestProperties[name] = value;

        this.addRequestParameter(name, value, true); // immer mitgeben. spätestens seit Callfunction-APIs wird das Zeug immer im jsonData benötigt!
    }

    /**
     * Falls der Controller einen anderen Requestparameter als "jsonData" erwartet, kann dessen Namen hier geändert werden.
     * @param name Name des Haupt-Requestparameters
     */
    setGlobalRequestParameterName(name: string = "jsonData") {
        this._requestParameterName = name;
    }

    /**
     * Weitere Parameter für den globalen Request mitgeben.
     * @param name Name des Parameters, den der Request-Controller erwartet
     * @param value Wert des Parameters
     * @param addToJsonRequest Parameter wird den allgemeinen Requestdaten (Standard: 'jsonData') zugefügt als Property
     */
    addRequestParameter(name: string, value: any, addToJsonRequest: boolean = true) {
        if (!this._globalRequestParameters) {
            this._globalRequestParameters = [];
        }

        for (let entry of this._globalRequestParameters) {
            if (entry.name == name) {
                entry.value = value;
                return;
            }
        }

        this._globalRequestParameters.push({ name: name, value: value, standaloneParam: addToJsonRequest != true });
    }

    private _globalRequestParameters: Array<{ name: string, value: any, standaloneParam: boolean}> = null;

    setValues(values: Array<Types.Entry<T>> /*| Array<string>*/ | Array<Types.Item<T>> | Array<T>) {
        if (!this.dlg) { // das bedeutet: der Dialog ist noch garnicht "fertig" gestartet. Also values zurückstellen und später nochmal hierher
            this.targetValues = values;
            return;
        }

        this.deselectAll();

        this.targetValues = [];

        if (values && values.length) {

            for (let presetItem of values) {
                let value: string = "";
                let label: string = "-";
                let labelSecondary: string = null;
                let entityData: T = null;

                if (typeof (presetItem) == "string") {
                    value = presetItem;
                    // labels können wir nicht erfinden...
                }

                // ist es ein Item?
                else if ((presetItem as any).entry) {
                    let existingItem: Types.Item<T> = presetItem as any;
                    value = existingItem.entry.value;
                    label = existingItem.entry.label;
                    labelSecondary = existingItem.entry.label;
                }
                // ist es ein Entity?
                else if (presetItem[this.valueAttribute]) {
                    let entity: T = presetItem as T;
                    value = entity[this.valueAttribute];
                    label = entity[this.labelAttribute];
                    labelSecondary = entity[this.secondaryLabelAttribute];
                }

                let availableItem = null;
                for (let item of this.availableItems) {
                    if (item.entry && item.entry.value == value) {
                        availableItem = item;

                        value = item.entry.value;
                        label = item.entry.label;
                        labelSecondary = item.entry.secondaryLabel;

                        break;
                    }
                }

                let item = availableItem;
                if (!availableItem) {
                    // kein Item zufällig sichtbar gefunden

                    let pseudoitem: Types.Item<T> = {
                        entry: null,
                        node: null,
                        selected: true,
                        sourceTree: null
                    };

                    // prüfen ob das mitgegebene Array Items oder Entries enthält
                    let entry: Types.Entry<T> = null;
                    if (typeof (presetItem) == "object") {
                        // wenn es das entry-Property gibt, dann ist es ein item und wir brauchen uns das entry nur holen.
                        if ((<Types.Item<T>>presetItem).entry) {
                            entry = (<Types.Item<T>>presetItem).entry;
                            pseudoitem.sourceTree = (<Types.Item<T>>presetItem).sourceTree;
                        } else {
                            // das Array enthält Entries. dann können wir das nutzen
                            entry = <Types.Entry<T>>presetItem;
                        }
                    } else {
                        entry = {
                            label: label,
                            value: value,
                            secondaryLabel: labelSecondary
                            //data?: null
                        };
                    }

                    pseudoitem.entry = entry;
                    item = pseudoitem;
                }



                this.selectItem(item);
            }
        }
    }

    enableOverflow(bEnable: boolean) {
        this.dlg.enableContentOverflow(bEnable);
    }


    setup(title: string, callbackFct: (values: Array<string>, items: Array<SelectEntityDialogTypes.Item<T>>) => any,
        requestUrlOrFunction: string,
        entriesPerPage: number = 10,
        trees?: Array<Types.Tree<T>>,
        rules?: Types.DlgRule,
        labelAttribute?: string,
        valueAttribute?: string,
        secondaryLabelAttribute?: string,
        enableSelectAll?: boolean) {
        this.dlgTitle = title;
        this.callback = callbackFct;

        //if (valueProperty) {
        //    this.valueProperty = valueProperty;
        //}
        let enableSelectNone = false;
        let showSelectionTab = false;// this.showSelectedTab;
        let multiselect = false;

        if (labelAttribute) {
            this.labelAttribute = labelAttribute;
        }
        if (secondaryLabelAttribute) {
            this.secondaryLabelAttribute = secondaryLabelAttribute;
        }
        if (valueAttribute) {
            this.valueAttribute = valueAttribute;
        }

        if (rules) {
            this.rules = rules;
            if (rules.maxSelect <= 0 || rules.maxSelect == 0) {
                this.rules.maxSelect = null;
            }
            if (rules.ruleLabel) {
                this.UiModder.domAttr.set(this.rulesLabel, "innerHTML", rules.ruleLabel);
                this.UiModder.domClass.remove(this.rulesLabelContainer, "w3-hide");
            }

            if (rules.maxSelect != 1) multiselect = true;
            if (rules.minSelect == 0) enableSelectNone = true;
        }

        showSelectionTab = multiselect === true;


        if (requestUrlOrFunction) this.requestUrlOrFunction = requestUrlOrFunction;

        if (trees && trees.length) {
            this.setTrees(trees);
        }


        this.allowEmptyValue = enableSelectNone === true;
        this._enableMultiselect = multiselect === true;
        this.UiModder.domClass.toggle(this.mainContainer, "multiselectable", this._enableMultiselect);

        if (entriesPerPage) {
            this._entriesPerPage = entriesPerPage;
        }

        if (enableSelectAll) this._enableSelectAll = enableSelectAll;
        if (this._enableMultiselect) this.closeOnSelect = false;
        this.selectionTabEnabled = this._enableMultiselect && showSelectionTab !== false;
        this.UiModder.domClass.toggle(this.selectionTabContainer, "w3-hide", this.selectionTabEnabled !== true);
        this._updateItemSelectionCountLabels();
        this._checkRules();

        // haut nicht hin: Umschalten auf ordentlichen lokalen Suchmodus geht irgendwie noch nicht. besser normal mit Suchrequest laufen lassen
        //if (initialResultlist?.length) {
        //    if (this._searchTimeoutFct) clearTimeout(this._searchTimeoutFct);
        //    if (this._isRequestActive) this.RequestManager.cancelRunningRequests();
        //    if (this._requestHandle) {
        //        this._requestHandle.cancel();
        //    }
        //    //this._selectedTree._lastRequestResponse = initialResultlist;
        //    this._onGetRequestResult(initialResultlist);
        //}


    //    this.labelProperty = labelProperty;
    //    this.secondaryLabelProperty = secondaryLabelProperty;
    }

    setTrees(trees: Array<Types.Tree<T>>) {
        for (let tree of this.trees) {
            this.UiModder.domConstruct.destroy(tree.selectorNode);
        }

        this.trees = [];
        let selectedTree = null;

        if (trees && trees.length) {
            for (let tree of trees) {
                if (tree._initialSelected === true) selectedTree = selectedTree;

                this.addTree(tree.name,
                    tree.label,
                    tree.searchPrompt,
                    tree.contentLabel,
                    tree.description,
                    tree.icon,
                    tree.hideSearchInput,
                    tree.rules,
                    tree.filterpanel,
                    tree.requestUrlOrFunction,
                    tree._requestParams,
                    tree.additionalData
                   );
            }

        }

        if (selectedTree) this._switchToTree(selectedTree);

    }

    getSelectedItems(): Array<SelectEntityDialogTypes.Item<T>> {
        return this.selectedItems;
    }
    getSelectedEntities(): Array<T> {
        let entities: Array<T> = [];
        for (let item of this.selectedItems) {
            entities.push(item.entry.data);
        }

        return entities;
    }
    getSelectedTreeName(): string {
        return this._selectedTree.name;
    }

    getSelectedTree(): Types.Tree<T> {
        return this._selectedTree;
    }

    getFilterPanel(treename: string): MdsLax<InstanceType<typeof FilterPanelWidget>> {
        let tree = this.getTreeByName(treename);
        if (tree) { return tree._filterPanel };

        return null;
    }

    private getTreeByName(name: string): Types.Tree<T> {
        let index: number = this.getTreeIndexByName(name);

        if (index >= 0) return this.trees[index];
    }

    private getTreeIndexByName(name: string): number {
        if (!name) {
            return -1;
        }
        let index = 0;
        for (let tree of this.trees) {
            if (tree.name == name) {
                return index;
            }
            index++;
        }

        return -1;
    }


    /**
     * Einen Tree-Tab zum Dialog hinzufügen
     * @param name Interner Name
     * @param title Bezeichnung des wählbaren Tabs (kurz)
     * @param searchPrompt Hinweis im Suchfeld (leer = Standard)
     * @param contentTypeLabel Kurze Bezeichnung des Inhaltstyps
     * @param description Hinweise zum und Beschreibung des Trees
     * @param icon Icon-Klasse, zb. "fas fa-filter"
     * @param hideSearch Suchfeld ausblenden
     * @param additionalRequestParams Beliebige Parameter, die beim Request übergeben werden
     * @param additionalData Beliebige weitere Daten, die als solche unverändert beim Request mitgegeben werden
     * @param requestUrlOrFunction URL, falls abweichend vom restlichen Dialog oder API-Functionname
     * @param filterpanelConfig Konfiguration eines Filterpanels mit weiteren Suchparametern
     */
    addTree(name: string,
        title: string,
        searchPrompt?: string,
        contentTypeLabel?: string,
        description?: string,
        icon?: string,
        hideSearch: boolean = false,
        rules?: Types.TreeRule,
        filterpanelConfig?: FilterPanelTypes.PanelConfig,
        requestUrlOrFunction?: string,
        additionalRequestParams?: Object,
        additionalData?: any) {
        let existringtreeIndex = this.getTreeIndexByName(name);
        if (existringtreeIndex >= 0) {
            let existringTree = this.getTreeByName(name);
            this.UiModder.domConstruct.destroy(existringTree.selectorNode);
            this.trees.splice(existringtreeIndex, 1);
        }

        let button = this.UiModder.domConstruct.create("button", {
            "className": "mds-button-base square treebutton tertiaryBG hoverBright",
            "innerHTML": ""
        }, this.treeTabContainer);
        let label = this.UiModder.domConstruct.create("div", {
            "innerHTML": "",
            "className": "label"
        }, button);

        this.UiModder.domConstruct.create("div", { "id": "text", "innerHTML": title }, label);

        let iconContainer = this.UiModder.domConstruct.create("div", {
            "id": "iconContainer",
            "className": "w3-hide"
        }, label, "first");

        let iconNode = this.UiModder.domConstruct.create("i", {}, iconContainer);
        let warningIcon = this.UiModder.domConstruct.create("i", { className: "fas fa-exclamation-triangle", "id": "warningIcon"}, iconContainer);

        if (icon) {
            this.UiModder.domClass.add(iconNode, icon);
            this.UiModder.domClass.remove(iconContainer, "w3-hide");
        }

        let ruleLabel = null;
        if (rules) {
            if (rules.ruleLabel) {


                let bottomLabel = this.UiModder.domConstruct.create("div", {
                    className: "rulesLabel",
                    "innerHTML": ""
                }, button);

                let text = rules.ruleLabel;
                if (text) {
                    this.UiModder.domAttr.set(bottomLabel, "innerHTML", text);
                }

                ruleLabel = bottomLabel;
            }
        }

        button.setAttribute("label", label.innerText);


        // button klonen und auf sich selber setzen - wird erst beim Aktivieren sichtbar geschaltet
        //let activeDummy = <HTMLElement>button.cloneNode(true);
        //this.UiModder.domConstruct.place(activeDummy, button);
        //this.UiModder.domAttr.set(activeDummy, "id", "activeDummy");

        let tree: Types.Tree<T> = {
            name: name,
            label: title,
            icon: icon,
            iconNode: iconNode,
            hideSearchInput: hideSearch,
            rules: rules,
            contentLabel: contentTypeLabel,
            description: description,
            selectorNode: button,
            ruleLabelNode: ruleLabel,
            searchPrompt: searchPrompt ? searchPrompt : this.translate("SelectEntityDlg__SearchPromptDefault"),
            additionalData: additionalData,
            _filterPanel: null,
            _loadedSearchValue: this._searchValue,
            //resultPages: [],
            _requestParams: {},
        };

        if (requestUrlOrFunction) {
            tree.requestUrlOrFunction = requestUrlOrFunction;
        }


        //if (additionalData) {
        //    for (let key in additionalData) {
        //        tree._requestParams[key] = additionalData[key];
        //    }
        //}

        if (additionalRequestParams) {
            for (let key in additionalRequestParams) {
                tree._requestParams[key] = additionalRequestParams[key];
            }
        }

        if (filterpanelConfig) {
            let FilterPanelClass: any = mdsRequire("moreCore/UI/FilterPanel/FilterPanel"); //NOTE - dynamic require wegen loop import
            tree.filterpanel = filterpanelConfig;
            tree.filterpanel.name = location.pathname + this.id + "-" + tree.name;
            tree._filterPanel = new FilterPanelClass;
            tree._filterPanel.outputFormat = FilterPanelFormat.default;// tree.filterpanel.format;

            tree._filterPanel.setConfig(tree.filterpanel);
            on(tree._filterPanel, "change", lang.hitch(this, this._onChange_Filterpanel, tree));

            tree._filterPanel.hideSectionIfSingle(true);
        }

        //if (customLabelProperty) {
        //    tree.labelProperty = customLabelProperty;
        //}

        //if (customSecondaryLabelProperty) {
        //    tree.secondaryLabelProperty = customSecondaryLabelProperty;
        //}

        this.trees.push(tree);

        this.hideNode(this.treeTabContainer, this.trees.length <= 1);

        on(button, "click", lang.hitch(this, this._onClick_TreeTab, tree));

        if (this.trees.length == 1) {
            //this._currentTree = this.trees[0];
            this._switchToTree(tree);
            //this.treeTabContainer.set("value", name);
        }


    }

    private _onClick_TreeTab(targetTree: Types.Tree<T>, evt?: MouseEvent) {
        if (targetTree._locked === true) return;

        if (this._showSelected === true) {
            this.hideSelectedItems();
        }

        if (targetTree != this._selectedTree)
        {
            this._switchToTree(targetTree);
        }

        if (evt) {
            evt.stopPropagation();
        }


    }

    private lockTrees(exceptionTreeName: string) {
        for (let tree of this.trees) {
            if (tree.selectorNode && tree.name != exceptionTreeName) {
                this.UiModder.domClass.add(tree.selectorNode, "w3-disabled");
                tree._locked = true;
            }
        }
    }

    private unlockTrees() {
        for (let tree of this.trees) {
            if (tree.selectorNode) {
                this.UiModder.domClass.remove(tree.selectorNode, "w3-disabled");
                tree._locked = false;
            }
        }
    }
    private _treeHasChanged: boolean = true;
    private _switchToTree(targetTree: Types.Tree<T>) {

        if (this._selectedTree) {

            if (targetTree.name == this._selectedTree.name) {
                return;
            }
        }

        if (this._isRequestActive) {
            this.RequestManager.cancelRunningRequests();
        }

        // Baum-Tab optisch umschalten
        if (this._selectedTree) {
            if (this._selectedTree._filterPanel) {
                this.UiModder.domConstruct.place(this._selectedTree._filterPanel.domNode, this.hiddenContainer);
            }
            if (this._selectedTree.selectorNode) {
                this.UiModder.domClass.remove(this._selectedTree.selectorNode, "selected");
            }
        }
        this._selectedTree = targetTree;
        this.UiModder.domClass.add(this._selectedTree.selectorNode, "selected");

        this.UiModder.domClass.toggle(this.treeDescriptionContainer, "w3-hide", true);
        this.UiModder.domAttr.set(this.treeDescription, "innerHTML", "");

        if (this._selectedTree.description) {
            this.UiModder.domClass.toggle(this.treeDescriptionContainer, "w3-hide", false);
            this.UiModder.domAttr.set(this.treeDescription, "innerHTML", this._selectedTree.description);
        }


        if (this._selectedTree._filterPanel) {
            this.UiModder.domConstruct.place(this._selectedTree._filterPanel.domNode, this.filterPanelContainer);
            this._selectedTree._filterPanel.focusFirstVisibleOption();
            let value = this._selectedTree._filterPanel.getData();
            let strValue = null;
            if (value != null) strValue = JSON.stringify(value);
            this._searchValue = strValue;
        } else if (this._selectedTree.hideSearchInput != true) {
            this._searchValue = this._selectedTree._loadedSearchValue;
            this.searchInput.value = this._searchValue;
            this.UiModder.domAttr.set(this.searchInput, "placeholder", this._selectedTree.searchPrompt);
        } else {
            this._searchValue = "";
        }

        this._treeHasChanged = true;

        // auf Seite 1 schalten        
        this.setPage(1, true);

        this.UiModder.domAttr.set(this.searchInput, "placeholder", targetTree.searchPrompt);

        this.UiModder.domClass.toggle(this.searchInput, "w3-hide", targetTree.hideSearchInput === true || targetTree._filterPanel != null);


        //console.log("changeTree", selectedTree, button);


        this.delaySearch(0);
        this.UiModder.domClass.add(this.resultContainer, "w3-disabled");
        this.UiModder.domClass.add(this.bottomContainer, "w3-disabled");
    }

    private _progressHandle: any = null;
    private startProgressBar() {

        this._progressHandle = setTimeout(lang.hitch(this, this.UiModder.domClass.add, this.progressContainer, "loadingBar"), 1);// 1200);

    }
    private stopProgressBar() {
        if (this._progressHandle) {
            clearTimeout(this._progressHandle);
        }

        this.UiModder.domClass.remove(this.progressContainer, "loadingBar");
    }

    private _onKeyUp_SearchInput(evt: KeyboardEvent) {
        //this.RequestManager.cancelRunningRequests();
        let value = this.searchInput.value;

        if (value == "" || value == null) {
            value = "";
        }

        // damit unterbinden wir unnötige Requests, wenn zb nur der Cursor mit Pfeiltasten bewegt worden ist:
        if (value != this._searchValue) {
            this._searchValue = value;
            this.disableNode(this.resultContainer);
            this.setPage(1);
        }
    }

    private _onChange_Filterpanel(tree: SelectEntityDialogTypes.Tree<T>, changeEventData: any) {

        if (!tree || tree.name != this._selectedTree?.name) return;

        let value = this._selectedTree._filterPanel.getData();
        let strValue = null;
        if (value != null) strValue = JSON.stringify(value);
        //console.log("_onChange_Filterpanel", data, value);

        if (this._searchValue == strValue) return;

        this._searchValue = strValue;

        this.setPage(1);

        this.emit("filterpanelChange", this._selectedTree?.name);
    }


    private getStartIndexFromPage(pageNumber: number = 0): number {
        if (typeof (pageNumber) != "number") {
            pageNumber = this._targetPageNumber;
        }

        if (pageNumber < 1) {
            pageNumber = 1;
        }

        return 0 + (pageNumber - 1) * this._entriesPerPage;

    }


    private _searchTimeoutFct: number = null;

    private delaySearch(delay?: number) {


        if (typeof(delay) != "number") {
            delay = 544;
        }
        if (this._requestHandle) {
            if (typeof this._requestHandle.cancel == 'function'){
                this._requestHandle.cancel();
            }else if (typeof this._requestHandle.abort == 'function'){
                this._requestHandle.abort();
            }
        }
        this.RequestManager.cancelRunningRequests();
        if (this._searchTimeoutFct != null) {
            this.stopProgressBar();
            clearTimeout(this._searchTimeoutFct);
            this._searchTimeoutFct = null;
        }
        if (this._searchTimeoutFct == null) {
            this._searchTimeoutFct = setTimeout(lang.hitch(this, this._loadResultRows), delay);
        }

        //console.log("searchparameters", this.parameters);
    }

    private _loadResultRows() {
        let searchText = this._searchValue;
        let startIndex = this.getStartIndexFromPage();
        let filterpanelValue = null;

        if (this._selectedTree.hideSearchInput === true && this._selectedTree._filterPanel == null) searchText = "";
        else if (this._selectedTree._filterPanel) {

            filterpanelValue = this._selectedTree._filterPanel.getData(true);
        }


        clearTimeout(this._searchTimeoutFct);
        this._searchTimeoutFct = null;


        if (!searchText) {
            searchText = "";
        }

        if (typeof (startIndex) == "undefined") {
            startIndex = 0;
        }

        if (this._treeHasChanged == true) {
            // dann muss die Suche bitte ausgeführt werden, auch wenn sich Pagenumber und Suchbegriff nicht geändert haben
            // bitte wie hat das überhaupt bisher funktionieren können??
        }
        else if (this._selectedTree._loadedSearchValue == searchText && this._displayedPageNumber == this._targetPageNumber) {
            return;
        }

        if (!this.requestUrlOrFunction || this.requestUrlOrFunction == "?") {
            alert(this.id + ": no request url oder callfunction set for loading results!");
            ///console.error(this.id + ": missing request url or callfunction")
            return;
        }

        //if (!searchText) {
        //    this.UiModder.domConstruct.empty(this.resultlist._tableBodyNode);
        //    this.UiModder.domConstruct.empty(this.paginationContainer);
        //    //

        //    this._previousSearchValue = null;
        //    this._previousPage = -1;

        //    return;
        //}

        this.hideNode(this.noResultContainer);

        this.startProgressBar();
        this.disableNode(this.resultContainer);
        this.UiModder.domClass.add(this.bottomContainer, "w3-disabled");

        let requestTarget = this.requestUrlOrFunction;
        if (this._selectedTree && this._selectedTree.requestUrlOrFunction) {
            requestTarget = this._selectedTree.requestUrlOrFunction;
        }


        let data = {
            limit: this._entriesPerPage,
            startIndex: this.getStartIndexFromPage(this._targetPageNumber),
            treeName: this._selectedTree.name,
            searchText: searchText
        };
        if (filterpanelValue && searchText) { // Achtung: wenn
            data["filterSections"] = filterpanelValue;
            data.searchText = null;
        }

        if (this._selectedTree.additionalData) {
            for (let key in this._selectedTree.additionalData) {
                data[key] = this._selectedTree.additionalData[key];
            }
        }

        if (this._selectedTree && this._selectedTree._requestParams) {
            for (let key in this._selectedTree._requestParams) {
                data[key] = this._selectedTree._requestParams[key];
            }
        }

        if (this._globalRequestProperties) {
            for (let key in this._globalRequestProperties) {
                data[key] = this._globalRequestProperties[key];
            }
        }
        if (this._globalRequestParameters) {
            for (let param of this._globalRequestParameters) {
                data[param.name] = param.value;
            }
        }


        if (requestTarget && requestTarget.indexOf("/") == -1) {
            // es ist eine Callfunction!
            this._requestHandle = this.RequestManager.callfunction(
                requestTarget,
                data,
                lang.hitch(this, this._onGetRequestResult),
                lang.hitch(this, this._onGetRequestError)
            );
        }
        else {
            // für normale post-Requests alle Properties stringifiziert in die Requestdaten packen!

            let requestData = {

            };

            requestData[this._requestParameterName] = data;

            // erweitern um die anderen Parameter
            if (this._globalRequestParameters) {
                for (let entry of this._globalRequestParameters) {
                    if (entry.standaloneParam) {
                        if (typeof (entry.value) == "object" && !!entry.value) {
                            requestData[entry.name] = JSON.stringify(entry.value);
                        } else {
                            requestData[entry.name] = entry.value;
                        }
                    } else {
                        requestData[this._requestParameterName][entry.name] = entry.value;
                    }
                }
            }


            if (this._selectedTree && this._selectedTree._requestParams) {
                for (let key in this._selectedTree._requestParams) {
                    let value = this._selectedTree._requestParams[key];
                    if (typeof (value) == "object" && !!value) {
                        requestData[key] = JSON.stringify(value);
                    }
                    else {
                        requestData[key] = value;
                    }


                }
            }

            if (this._globalRequestProperties) {
                for (let key in this._globalRequestProperties) {
                    requestData[this._requestParameterName][key] = this._globalRequestProperties[key];
                }
            }

            requestData[this._requestParameterName] = JSON.stringify(requestData[this._requestParameterName]);



            let url = window.appRoot + requestTarget;
            this._requestHandle = this.RequestManager.post(
                url,
                requestData,
                lang.hitch(this, this._onGetRequestResult),
                lang.hitch(this, this._onGetRequestError),
                false // sync
            );
        }


    }
    private _requestHandle: any = null;

    private _StandbyStart(node?: HTMLElement){//, stepName?: string, stepLabel?: string, stepCallback?: Function, groupName?: string) {
        this.startProgressBar();
        this.disableNode(this.resultContainer);
        this.UiModder.domClass.add(this.bottomContainer, "w3-disabled");
        return null;
    }

    private _StandbyStop() {
        this.stopProgressBar();
        this.disableNode(this.resultContainer, false);
        this.UiModder.domClass.remove(this.bottomContainer, "w3-disabled");
    }


    private _onGetRequestResult(response: more.PackedEntitylistResult<Types.Entry<T>> | Array<any>) {

        // beide Fälle annehmen:
        let packedResponse = response as more.PackedEntitylistResult<Types.Entry<T>>;
        let anyResponse = response as Array<any>;

        this._requestHandle = null;

        let entities = [];

        let count = -1;


        // ist es ein packed result? Anhand der Properties prüfen:
        if (typeof (packedResponse.entitylist?.length) == "number" || (typeof (packedResponse.totalResultCount) == "number" && typeof (packedResponse.startIndex) == "number")) {
            // wenn jemand in der API vergessen hat, die Resultlist zu paginieren, dann wird als Startindex nichts oder 0 kommen, auch wenn wir schon geblättert haben
            let reportedStartIndex = 0;
            let actualFirstIndex = reportedStartIndex;

            let targetStartIndex = this.getStartIndexFromPage(this._targetPageNumber); // deshalb auch den SOLL-Wert mal berechnen

            // falls nur die Entityliste daherkommt: internen SOLL-Index annehmen
            if (packedResponse.startIndex == undefined) {
                packedResponse.startIndex = targetStartIndex;
            }
            if (packedResponse.totalResultCount == undefined) {
                packedResponse.totalResultCount = packedResponse.entitylist ? packedResponse.entitylist.length : 0;
            }


            if (packedResponse && packedResponse.entitylist && packedResponse.entitylist.length) {
                // wir gehen mal davon aus, dass die Entitylist schon paginiert ist, also der Anzahl pro Seite entspricht
                entities = packedResponse.entitylist;
                reportedStartIndex = packedResponse.startIndex;
                actualFirstIndex = 0; // in dem Fall einfach die Liste von ganz vorne verwenden

                
            }

            // wenn SOLL und IST jetzt nicht passen, dann den internen verwenden, weil vermutlich haben wir mehr Ergebnisse als wir brauchen
            // es kommen zb 36 entities, obwohl nur 10 pro Seite gefragt wären
            // dann steht als totalResultCount: 36, wir haben auch alle 36 im Array
            // in dem Fall den eigens berechneten Wert verwenden
            if (reportedStartIndex != targetStartIndex && packedResponse.totalResultCount >= this._entriesPerPage) {
                if (entities.length > this._entriesPerPage && entities.length == packedResponse.totalResultCount) {
                    actualFirstIndex = targetStartIndex;
                }
            }
            count = packedResponse.totalResultCount;

            this._selectedTree._lastRequestResponse = packedResponse;
            this.setPagingStyle();

            if (!this._initialAspectAfterHandle) {
                // die Entities zeichnen
                //this.itemContainer = this.UiModder.domConstruct.create("div", { "className": "itemContainer" }, this.resultContainer, "only");
                this.UiModder.domConstruct.empty(this.itemContainer);
                this.hideNode(this.itemContainer, this._showSelected);

                this.availableItems = [];
                let index = 0;
                for (let entry of entities) {
                    if (index >= actualFirstIndex) {
                        this.availableItems.push(this._constructSelectionItem(entry));

                        if (this.availableItems.length == this._entriesPerPage) break;
                    }

                    index++;
                }

                if (this.targetValues && this.targetValues.length) {
                    this.setValues(this.targetValues);
                }
            }
        }
        // ist es ein einfaches Array?
        else if (typeof (anyResponse.length) == "number" && lang.isArray(anyResponse)) {


            if (!this.labelAttribute || !this.valueAttribute) {
                let unknownResponse = anyResponse;
                anyResponse = [];
                //alert(this.id + ": missing labelattribute or valueattribute for this response!");
                // versuchen, die Einträge zu übersetzen in normierte, falls nötig

                for (let unknown of unknownResponse) {
                    let entry = this.translateObjectIntoEntry(unknown);
                    if (entry) {
                        anyResponse.push(entry);
                    }
                }

                if (anyResponse.length != unknownResponse.length) alert(this.id + ": missing labelattribute or valueattribute for this response!");

            }
            this._selectedTree._lastRequestResponse = anyResponse;
            // aus dem einfachen Array eine "packed response" faken
            count = anyResponse.length;

            let drawnList = this._drawFromAnyResponseArray(anyResponse);
            count = drawnList.totalResultCount;

            if (this.targetValues && this.targetValues.length) {
                this.setValues(this.targetValues);
            }
        }

        else {
            this.StandbyStop();
            alert(this.id + ": invalid response format\r\n" + JSON.stringify(response));
            return;
        }

        // Paging berechnen und Auswahlbuttons zeichnen!

        this.hideNode(this.resultContainer, count == 0);
        this.hideNode(this.noResultContainer, count > 0);

        if (!this._selectedTree._filterPanel && !this._selectedTree.hideSearchInput) this._selectedTree._loadedSearchValue = this._searchValue;
        this._treeHasChanged = false; // auf false resetten und nächsten Request nicht erzwingen

        //this._resetResults(); // ????


        this.StandbyStop();
    }

    private _getLocalSearchResults(searchValue: string): Array<T> {
        let results = [];

        let data = [];
        let useSimpleEntityArray: boolean = false;
        if (lang.isArray(this._selectedTree._lastRequestResponse)) {
            data = this._selectedTree._lastRequestResponse;
            useSimpleEntityArray = true;
        } else {
            data = this._selectedTree._lastRequestResponse.entitylist;

        }

        if (searchValue && searchValue != "" && typeof (searchValue) == "string") {
            searchValue = searchValue.toLowerCase();
            for (let i = 0; i < data.length; i++) {
                let entity = data[i];
                let dispValue: string = "";

                if (useSimpleEntityArray) {
                    dispValue = entity[this.labelAttribute] ? entity[this.labelAttribute] : "??";

                } else {
                    let entry = entity as Types.Entry<T>;
                    dispValue = entry.label;

                    //if (entry.secondaryLabel) {

                    //}
                }
                if (typeof (dispValue) == "string") {
                    if (dispValue.toLowerCase().indexOf(searchValue) != -1) {
                        results.push(entity);
                    }
                }
            }

            return results;
        } else {
            return data;
        }
    }

    private _drawFromAnyResponseArray(dataArray: Array<any>): more.PackedEntitylistResult<Types.Entry<T>> {

        let entities = [];
        let startIndex = this.getStartIndexFromPage(this._targetPageNumber);
        let count = 0;

        let filteredArray = this._getLocalSearchResults(this._searchValue);

        for (let index = 0; index < filteredArray.length; index++) {
            if (index >= startIndex) {
                let entity = filteredArray[index];
                let labelVal = EntityHelpers.getComplexProperty(entity, this.labelAttribute);
                let secondaryLabelVal = EntityHelpers.getComplexProperty(entity, this.secondaryLabelAttribute);
                let val = EntityHelpers.getComplexProperty(entity, this.valueAttribute);

                let entry: Types.Entry<T> = {
                    label: typeof (labelVal) == "string" ? labelVal : "?labelattribute?",
                    value: typeof (val) == "string" ? val : "?valueAttribute?",
                    secondaryLabel: secondaryLabelVal ? secondaryLabelVal : null,
                    data: entity
                };
                entities.push(entry);
                count++;
            }

            if (count == this._entriesPerPage) {
                break;
            }
        }

        let result: more.PackedEntitylistResult<Types.Entry<T>> =
        {
            entitylist: entities,
            startIndex: startIndex,
            totalResultCount: filteredArray.length,
            currentLimit: this._entriesPerPage,
            layouts: null
        };

        if (!this._initialAspectAfterHandle) {
            // die Entities zeichnen
            //this.itemContainer = this.UiModder.domConstruct.create("div", { "className": "itemContainer" }, this.resultContainer, "only");
            this.UiModder.domConstruct.empty(this.itemContainer);
            this.UiModder.domClass.toggle(this.itemContainer, "w3-hide", this._showSelected);
            this.availableItems = [];
            for (let entry of entities) {
                this.availableItems.push(this._constructSelectionItem(entry));
            }

            this.disableNode(this.resultContainer, false);
        }

        this.setPagingStyle();

        this.hideNode(this.noResultContainer, filteredArray.length > 0);
        this.hideNode(this.resultContainer, !filteredArray.length);

        return result;
    }

    _onGetRequestError(error: more.requestErrorMessage) {
        this.stopProgressBar();
        this._requestHandle = null;
        //this.UiModder.domClass.remove(this.resultContainer, "w3-disabled");
        //this.UiModder.domClass.remove(this.paginationContainer, "w3-disabled");

        let dlg = new GenericDialog();
        dlg.setSize("smaller");
        dlg._setHeaderAttr(this.translate("SelectEntityDlg_Error_Heading"));
        dlg._setContentAttr(error.Message);
        dlg._setTextIconAttr("fas fa-face-frown");
        dlg.propagateClick = false;
        dlg._setCancelBtnAttr(false);
        dlg.setCloseOnEscape(true);
        dlg._setCloseBtnAttr(true);
        dlg._setTopCloseBtnAttr(true);
        dlg.show();


    }

    setPage(pageNumber: number = 1, loadResults?: boolean) {
        if (!pageNumber || pageNumber < 1) {
            pageNumber = 1;
        }

        this._targetPageNumber = pageNumber;

        if (this._displayedPageNumber <= 0) this._displayedPageNumber = 1; // das passiert wenn der Dialog noch ganz frisch ist, dann ist noch kein Seitenwechsel passiert

        if (this._displayedPageNumber) {

            let currentButton = document.getElementById(this.id + "pageBtn-" + this._displayedPageNumber.toString());
            if (currentButton) this.UiModder.domClass.remove(currentButton, "selected hoverDark hoverBright");
        }
        this._hidePreview();
        this._displayedPageNumber = pageNumber;

        let selectedButton = document.getElementById(this.id + "pageBtn-" + this._displayedPageNumber.toString());
        if (selectedButton) this.UiModder.domClass.add(selectedButton, "selected hoverBright");

        if (this._selectedTree._lastRequestResponse && lang.isArray(this._selectedTree._lastRequestResponse)) {
            let result = this._drawFromAnyResponseArray(this._selectedTree._lastRequestResponse);
        }
        else if (loadResults === true) {
            this.delaySearch(20);
        }
        else if (this._searchValue != this._selectedTree._loadedSearchValue) {
            this.delaySearch(); // längeres delay
        }
    }

    private _calcPageNumberFromItemIndex(index: number): number {

        if (!this.isPagingEnabled || this._entriesPerPage < 1) {
            return 1;
        }

        let counter = 1;
        let currentIndex = 0;
        while (currentIndex + this._entriesPerPage < index) { // zb 0 + 30 = 30, index = 34
            index = index + this._entriesPerPage;
            counter++;
        }

        return counter;
    }

    private _getMaxIndexOfPage(pageNo: number, totalResultCount?: number): number {
        if (!totalResultCount && this._selectedTree._lastRequestResponse) {
            totalResultCount = this.getTotalResultCount(this._selectedTree);
        }

        if (!pageNo) {
            pageNo = this._targetPageNumber;
        }

        if (!totalResultCount || totalResultCount == 0 || pageNo < 1) return 0;

        if (!this.isPagingEnabled || this._entriesPerPage < 1) {
            return totalResultCount - 1;
        }

        let maxPage = this._getMaxPagesFromResult(totalResultCount);
        if (pageNo >= maxPage) {
            return totalResultCount - 1;
        }

        return pageNo * this._entriesPerPage - 1;
    }

    private _getMinIndexOfPage(pageNo: number, totalResultCount?: number): number {

        if (!pageNo) {
            pageNo = this._targetPageNumber
        }

        if (!this.isPagingEnabled || this._entriesPerPage < 1) {
            return -1;
        } else if (pageNo <= 1) {
            return 0;
        }


        let maxPage = this._getMaxPagesFromResult(totalResultCount);
        if (pageNo > maxPage) {
            return totalResultCount;
        }

        return pageNo * this._entriesPerPage - this._entriesPerPage;
    }
    private _getMaxPagesFromResult(totalResultCount?: number): number {
        if (!totalResultCount && this._selectedTree._lastRequestResponse) {
            totalResultCount = this.getTotalResultCount(this._selectedTree);
        }

        if (!totalResultCount || totalResultCount == 0) return 0;

        if (!this.isPagingEnabled || this._entriesPerPage < 1) {
            return 1;
        }
        let currentLimit = this._entriesPerPage ? this._entriesPerPage : 10;

        let numPagesDecimal = totalResultCount / currentLimit;
        let numPages = Math.ceil(numPagesDecimal);

        return numPages;
    }

    getTotalResultCount(tree?: Types.Tree<T>): number {
        if (!tree) {
            tree = this._selectedTree;
        }
        let totalResultCount = 0;

        if (lang.isArray(this._selectedTree._lastRequestResponse)) {
            totalResultCount = this._getLocalSearchResults(this._searchValue).length;
        } else {
            totalResultCount = this._selectedTree._lastRequestResponse.totalResultCount;
        }

        return totalResultCount;
    }

    private setPagingStyle(): void {

        //console.log("setPagingStyle", this.lastResponse, this.isDirty, this._currentPage);

        let pagesTotal = this._getMaxPagesFromResult();
        let currentPageNo = this._targetPageNumber;
        let resultIndexThisPage = this._getMinIndexOfPage(currentPageNo) + 1;
        let resultIndexMaxThisPage = this._getMaxIndexOfPage(currentPageNo) + 1;


        let shownPages: Array<number> = [];

        if (this.paginationContainer) {
            // wenns zu viele gibt: begrenzen auf Start, Ende und ein paar rund um die aktuelle Seite herum
            if (pagesTotal > 15) {
                shownPages.push(1);
                shownPages.push(2);
                shownPages.push(3);

                for (let x = this._targetPageNumber - 3; x < this._targetPageNumber + 4; x++) {
                    shownPages.push(x);
                }

                shownPages.push(pagesTotal - 2);
                shownPages.push(pagesTotal - 1);
                shownPages.push(pagesTotal - 0);
            }

            if (this._selectedTree._lastRequestResponse && !this._isRequestActive) {
                let indexPerPage = 0;

                let container = this.UiModder.domConstruct.create("div", {
                    className: "buttonGroup"
                });

                let insertSpacer: boolean = true;

                for (let pageNo = 1; pageNo <= pagesTotal; pageNo++) {

                    if (shownPages.indexOf(pageNo, 0) != -1 || shownPages.length == 0) {
                        insertSpacer = true;

                        // button zeichnen:
                        let button = this.UiModder.domConstruct.create("button", {
                            "className": "mds-button-base pagingButton",
                            "innerHTML": pageNo.toString(),
                            "id": this.id + "pageBtn-" + pageNo.toString()
                        }, container);
                        button.setAttribute("data-cy", "selectEntityDialog:pageBtn:" + pageNo.toString()); // E2E: Seiten-Button


                        if (pageNo == this._targetPageNumber) {
                            this.UiModder.domClass.add(button, "selected");

                        } else {
                            this.UiModder.domClass.add(button, "hoverBright");
                            on(button, "click", lang.hitch(this, this.setPage, pageNo, true));
                        }

                    } else {
                        if (insertSpacer) {
                            insertSpacer = false;

                            let spacer = this.UiModder.domConstruct.create("span", {
                                "className": "spacer",
                                "innerHTML": " • • • "
                            }, container);
                        }
                    }
                }

                //this.UiModder.domConstruct.empty(this.pagingContainer);
                this.UiModder.domConstruct.place(container, this.paginationContainer, "only");
                this.UiModder.domClass.remove(this.paginationContainer, "w3-disabled w3-hide");

            }
            else if (this._isRequestActive) {
                this.UiModder.domClass.add(this.paginationContainer, "w3-disabled");
            }
            else {
                this.UiModder.domConstruct.empty(this.paginationContainer);
                this.UiModder.domClass.add(this.paginationContainer, "w3-hide");

            }

        }



        if (this.resultInfoContainer) {
            /*
                0 - Gesamtzähler Ergebnisse
                1 - Anzahl gezeigte Ergebnisse
                2 - Gezeigte Ergebnisse ab X
                3 - Gezeigte Ergebnisse bis Y
                4 - Aktuelle "Seite"
                5 - Anzahl "Seiten"

                */
            if (this._selectedTree._lastRequestResponse && !this._isRequestActive) {
                let resultCount = this.getTotalResultCount();
                if (resultCount == 0) {
                    this.resultInfoContainer.innerHTML = "";// this.translate("General__NoEntries");
                    //    this.stringFormat(this.pagingInfoFormatstring,
                    //    this.lastResponse.totalResultCount.toString(),
                    //    "0",
                    //    "0",
                    //    "0",
                    //    "1",
                    //    "1"
                    //);
                } else {

                    this.resultInfoContainer.innerHTML = this.stringFormat(this.pagingInfoFormatstring,
                        resultCount.toString(),
                        this._entriesPerPage.toString(),
                        resultIndexThisPage.toString(),
                        resultIndexMaxThisPage.toString(),
                        this._targetPageNumber.toString(),
                        pagesTotal.toString()
                    );
                }

                this.UiModder.domClass.remove(this.resultInfoContainer, "w3-disabled w3-hide");
            } else if (this._isRequestActive) {
                this.UiModder.domClass.add(this.resultInfoContainer, "w3-disabled");
            }

        }

    }

    /**
     * Prüft, ob ein unbekanntes Objekt ein Entry ist oder  ein Entity.
     * Gibt ein Objekt mit den standardisierten Properties value und label (ggf. secondaryLabel) retour.
     */
    private translateObjectIntoEntry(unknown: any): Types.Entry<T>{
        if (!unknown) return null;

        let entry: Types.Entry<T> = null;

        let testEntity = unknown as Object;

        if (this.valueAttribute) {
            if (testEntity.hasOwnProperty(this.valueAttribute)) {
                if (this.labelAttribute) {
                    if (testEntity.hasOwnProperty(this.labelAttribute)) {
                        // in dem Fall ist eine Übersetzung besser!
                        entry = {
                            label: unknown[this.labelAttribute],
                            value: unknown[this.valueAttribute],
                            data: unknown
                        };

                        if (this.secondaryLabelAttribute && testEntity.hasOwnProperty(this.secondaryLabelAttribute)) {
                            entry.secondaryLabel = unknown[this.secondaryLabelAttribute];
                        }

                        if (this.colorationAttribute && testEntity.hasOwnProperty(this.colorationAttribute)) {
                            let colorValue = unknown[this.colorationAttribute] as more.EntityAPIColor;

                            if (typeof (colorValue) == "object") {
                                if (colorValue.BackColor) {
                                    entry.colorationBG = colorValue.BackColor.Hex;
                                }

                                if (colorValue.TextColor) {
                                    entry.colorationTXT = colorValue.TextColor.Hex;
                                }
                            }

                            else if (typeof (colorValue) == "string") {
                                entry.colorationBG = colorValue as string;
                            }
                        }

                        return entry;
                    }
                }
            }
        }

        if (testEntity.hasOwnProperty("label") && testEntity.hasOwnProperty("value")) {
            // dann müsste es als entry gelten
            return unknown;
        }

        return null;
    }

    private _constructSelectionItem(sourceData: any, parentContainer?: HTMLElement): Types.Item<T> {
        //let row = domConstruct.create("tr", null, );

        // Achtung: es kann sein, dass ein unvorsichtiger Programmierer (husthust) hier nicht Entries, sondern Entitys einschleust
        let entry = this.translateObjectIntoEntry(sourceData);
        if (!entry) {
            alert(this.id + ": malformed item! must be Object with label and value!");
            return null;
        }


        let container = this.itemContainer;
        if (parentContainer) container = parentContainer;

        let cell = this.UiModder.domConstruct.create("div", { className: "" }, container);

        //console.log("_addResultRow", entity);
        let btn = this.UiModder.domConstruct.create("div", {
            "className": "selectableItem hoverBright"
        });

        let labelcontainer = this.UiModder.domConstruct.create("div", {
            "className": "",
            "id": "labelContainer"
        }, btn);

        this.UiModder.domConstruct.place(btn, cell);

        let sourceTreeName = this._selectedTree.name;
        // Achtung: wenn wir gerade die selektierten anzeigen, dann finden wir jetzt jedes Entry in den selectedItems und holen uns den Treename daraus
        let existingItem = null;
        for (let selected of this.selectedItems) {
            if (selected.entry.value == entry.value) {
                if (this._showSelected === true) {
                    sourceTreeName = selected.sourceTree;
                } else {
                    existingItem = selected;
                }
                // wenn in den bereits selektierten ein passendes item ist, dann dieses wiederverwenden!
                break;
            }
        }


        let item: Types.Item<T> = existingItem;
        if (!existingItem) {
            item = { node: btn, selected: false, entry: entry, sourceTree: sourceTreeName };
        } else {
            item.node = btn;
        }

        let label = "?labelproperty?";
        let secondaryLabel = "";
        let previewContent: string = null;

        if (this.labelAttribute && entry[this.labelAttribute]) {
            label = entry[this.labelAttribute];
        }
        else if (typeof (entry.label) == "string") {
            label = entry.label;
            if (!label) {
                //label = this.createFontawesomeIcon("fas fa-remove-format w3-disabled").outerHTML;
                label = this.createFontawesomeIcon("fas fa-question w3-disabled").outerHTML;
            }
        }

        if (this.secondaryLabelAttribute && entry[this.secondaryLabelAttribute]) {
            secondaryLabel = entry[this.secondaryLabelAttribute];
        }
        else if (entry.secondaryLabel) {
            secondaryLabel = this.stringReplaceAll(entry.secondaryLabel, "\n", "<br>");
        }

        let labelElement = this.UiModder.domConstruct.create("div", {
            "className": "",
            "id": "label",
            "innerHTML": label
        }, labelcontainer);

        if (secondaryLabel) {
            let secondaryLabelElement = this.UiModder.domConstruct.create("div", {
                "className": "",
                "id": "secondarylabel",
                "innerHTML": secondaryLabel
            }, labelcontainer);
        }

        let rightSection = this.UiModder.domConstruct.create("div", {
            "id": "rightContainer"
        }, btn);

        let typeLabel = this.UiModder.domConstruct.create("div", {
            "className": "itemType"
        }, rightSection);

        if (entry.previewContent) {
            previewContent = entry.previewContent;

            // preview-icon inzwischen weg, weil eher verwirrend
            //let previewIcon = this.UiModder.domConstruct.create("button", {
            //    "className": "itemPreviewBtn mds-button-base hoverDark mediumBrightTransparentBG",
            //    "innerHTML": HtmlHelpers.createFontawesomeIcon("fas fa-info-circle").outerHTML,
            //    "id": "preview_" + entry.value
            //}, rightSection, "first");
            //on(previewIcon, "click", lang.hitch(this, this._onClickPreview, entry));

        }

        // Herkunft beschriften, wenn gerade alle gewählten Objekte gesammelt angezeigt werden:
        if (this._showSelected == true || item.sourceTree != this._selectedTree.name) {

            let tree = this.getTreeByName(item.sourceTree);
            if (tree) {
                this.UiModder.domConstruct.create("div", {
                    "className": "sourceTreename",
                    "innerHTML": tree.label
                }, rightSection);

                if (tree.contentLabel) {
                    this.UiModder.domAttr.set(typeLabel, "innerHTML", tree.contentLabel);
                }
            }
        }

        //this.UiModder.domAttr.set(btn, "innerHTML", label);


        on(btn, "click", lang.hitch(this, this._onClick_Select, item));

        this._updateItemSelectionState(item);
        return item;

    }

    private _onClick_Select(item: Types.Item<T>, evt: MouseEvent) {
        if (evt) evt.stopPropagation();

        if (item.selected) {
            this.deselectItem(item);

            this._updateItemSelectionCountLabels(); // ja, das könnte auch ins deselect, aber dann passierts bei deselectAll halt sehr oft
            return;
        }

        this.selectItem(item);

        if (item.entry.previewContent) this._showPreview(item.entry);
        else this._hidePreview();
    }

    private _shownPreviewID: string = null;

    private _onClickPreview(entry: Types.Entry<T>, evt: MouseEvent) {

        if (this._shownPreviewID == entry.value) this._hidePreview();
        else {
            this._showPreview(entry);
            setTimeout(lang.hitch(this.txtPreviewSelectionHeading, "scrollIntoView", { behavior: "smooth", inline: "nearest" }), 50);
        }

        if (evt) evt.stopPropagation();

    }

    private _showPreview(entry: Types.Entry<T>) {

        if (this._shownPreviewID == entry.value) return;
        if (entry.previewContent) {

            if (this._shownPreviewID) { // bestehendes deaktivieren!
                let btn = document.getElementById("preview_" + this._shownPreviewID);
                if (btn) this.UiModder.domClass.remove(btn, "active");
            }

            let btn = document.getElementById("preview_" + entry.value);
            if (btn) this.UiModder.domClass.add(btn, "active");
            //let container = this.UiModder.domConstruct.create("div",
            //    {
            //        className: "previewContent sectionBG",
            //        innerHTML: entry.previewContent
            //    }, this.previewContentNode, "only");

            let view = new SelectEntityDialogPreview();
            view.setContent(entry.previewContent);
            view.placeAt(this.previewContentNode, "only");

            this.txtPreviewSelectionHeading.innerHTML = entry.label;

            this.hideNode(this.previewSection, false);

            this._shownPreviewID = entry.value;
        }
    }

    private _hidePreview() {
        this.hideNode(this.previewSection);
        this.UiModder.domConstruct.empty(this.previewContentNode);


        let btn = document.getElementById("preview_" + this._shownPreviewID);
        if (btn) this.UiModder.domClass.remove(btn, "active");

        this._shownPreviewID = null;
    }

    deselectAll() {
        while (this.selectedItems.length > 0) {
            for (let item of this.selectedItems) {
                this.deselectItem(item);
            }
        }

        this.selectedItems = [];
        this._updateItemSelectionCountLabels();

        if (this._showSelected) {
            this.hideSelectedItems();
        }
    }

    selectAll() {
        for (let i = 0; i < this.availableItems.length; i++) {
            this.selectItem(this.availableItems[i]);
        }
    }

    private selectItem(item: Types.Item<T>) {
        if (!item) return;

        let duplicate = item as Types.ItemDuplicated<T>;
        // es ist VIELLEICHT nur das Duplikat für den "gewählte"-Tree, dann finden wir darauf ein sourceItem:
        if (this._showSelected && duplicate.sourceItem) {
            // also in Wirklichkeit das Sourceitem selektieren:
            this.selectItem(duplicate.sourceItem);
            duplicate.selected = true;
            // vom Duplikat nur den State upaten
            this._updateItemSelectionState(duplicate);

            return;
        }

        let values = this.getSelectedValues();
        let index = values.indexOf(item.entry.value);

        if (index == -1) {

            if (this._enableMultiselect) {
                this.selectedItems.push(item);
            } else {
                this.deselectAll();
                this.selectedItems = [item];
            }

            if (this.selectedItems.length && this.rules && this.rules.restrictToSingleTree === true && item.sourceTree) {
                this.lockTrees(item.sourceTree);
            }

            this._updateItemSelectionState(item);
            this._updateItemSelectionCountLabels();
        }
    }


    private deselectItem(item: Types.Item<T>) {
        if (!item) return;

        let duplicate = item as Types.ItemDuplicated<T>;
        // es ist VIELLEICHT nur das Duplikat für den "gewählte"-Tree, dann finden wir darauf ein sourceItem:
        if (this._showSelected && duplicate.sourceItem) {
            // also in Wirklichkeit das Sourceitem selektieren:
            this.deselectItem(duplicate.sourceItem);
            duplicate.selected = false;
            // vom Duplikat nur den State upaten
            this._updateItemSelectionState(duplicate);
        }

        for (let i = 0; i < this.selectedItems.length; i++) {
            let compareItem = this.selectedItems[i];
            if (compareItem.entry.value == item.entry.value) {

                compareItem.selected = false;
                compareItem.node = item.node;
                this.selectedItems.splice(i, 1);
                i--;

                if (this.selectedItems.length == 0 && this.rules && this.rules.restrictToSingleTree === true) {
                    this.unlockTrees();
                }

                // Achtung: die items in this.selectedItems können nach Seitenwechsel bereits neu gezeichnet worden sein!
                this._updateItemSelectionState(item);

                break;
            }
        }

        // während showSelected gibt es das item zweimal, weil es im "gewählt"-Baum dupliziert worden ist:
        if (this._showSelected === true) {
            item.selected = false;
            this._updateItemSelectionState(item);
        }
    }

    private _updateItemSelectionState(item: Types.Item<T>) {
        if (!item || !item.entry.value || !item.node) return;
        let values = this.getSelectedValues();
        let index = values.indexOf(item.entry.value);


        if (index != -1) {
            item.selected = true;
            this.UiModder.domClass.add(item.node, "selected");
        } else {
            item.selected = false;
            this.UiModder.domClass.remove(item.node, "selected");
        }
    }

    _onClick_ToggleSelected(evt: MouseEvent) {
        if (this.selectionTabEnabled != true || this._enableMultiselect != true) return;

        if (this._showSelected != true) {
            this.displaySelectedItems();
        } else {
            this.hideSelectedItems();
        }

        evt.stopPropagation();

    }

    private selectedItemContainer: HTMLElement;

    displaySelectedItems(bShow?: boolean) {
        this._showSelected = true;

        // die Entities zeichnen
        this.UiModder.domClass.add(this.bottomContainer, "w3-hide");
        this.selectedItemContainer = this.UiModder.domConstruct.create("div", { "className": "itemContainer" }, this.resultContainer);
        this.UiModder.domClass.add(this.itemContainer, "w3-hide");
        this.UiModder.domClass.toggle(this.filterContainer, "w3-hide", true);
        this.UiModder.domClass.toggle(this.btnShowSelection, "selected", true);
        if (this._selectedTree?.selectorNode) {
            this.UiModder.domClass.toggle(this._selectedTree.selectorNode, "selected", false);
        }

        for (let item of this.selectedItems) {
            let duplicateItem = this._constructSelectionItem(item.entry, this.selectedItemContainer) as Types.ItemDuplicated<T>;
            duplicateItem.sourceItem = item;
        }
    }

    hideSelectedItems() {
        this._showSelected = false;

        //this.UiModder.domClass.add(this.selectedItemContainer, "w3-hide");
        this.UiModder.domClass.remove(this.bottomContainer, "w3-hide");
        this.UiModder.domClass.toggle(this.filterContainer, "w3-hide", false);
        this.UiModder.domConstruct.destroy(this.selectedItemContainer);
        this.UiModder.domClass.toggle(this.btnShowSelection, "selected", false);
        if (this._selectedTree?.selectorNode) {
            this.UiModder.domClass.toggle(this._selectedTree.selectorNode, "selected", true);
        }

        this.UiModder.domClass.remove(this.itemContainer, "w3-hide");
        //this._onGetRequestResult(this._selectedTree._lastRequestResponse);

        this._updateItemSelectionCountLabels();
    }



    _onClick_SelectNone(evt: MouseEvent) {

        if (this.allowEmptyValue != true) {
            return;
        }

        this.deselectAll();

        this._onClick_Close(evt);

    }

    _onClick_SelectAll(evt: MouseEvent) {
        evt.stopPropagation();

        if (this._enableMultiselect) {
            this.selectAll();
        }
    }

    _onClick_Close(evt: MouseEvent) {
        this.selectedItems = [];
        this.callback(null);
    }

    private _checkRules(): boolean {
        let count = this.selectedItems.length;
        let valid = true;
        let basicRulesValid = true;

        if (!this.rules) {
            valid = count == 1 || (count == 0 && this.allowEmptyValue == true);
        }

        else {

            if (valid && this.rules.minSelect) {
                valid = count >= this.rules.minSelect;
            }

            if (valid && this.rules.maxSelect) {
                valid = count <= this.rules.maxSelect;
            }

            basicRulesValid = valid;

            let validTrees = this.trees.length;
            let invalidTrees = 0;

            validTrees = 0;

            let cntPerTree = [];
            let validPerTree = [];

            for (let tree of this.trees) {

                let validTreeRule = true;

                if (tree.rules && !tree._locked) {

                    validTreeRule = true;

                    let selectedInTree = 0;


                    for (let item of this.selectedItems) {
                        if (item.sourceTree == tree.name) {
                            selectedInTree++;
                        }
                    }

                    cntPerTree[tree.name] = selectedInTree;

                    if (tree.rules.minSelect >= 0) {
                        validTreeRule = validTreeRule && selectedInTree >= tree.rules.minSelect;
                    }

                    if (tree.rules.maxSelect >= 0) {
                        validTreeRule = validTreeRule && selectedInTree <= tree.rules.maxSelect;
                    }

                } else {
                    validTreeRule = true;
                }

                if (!validTreeRule) invalidTrees++;
                validPerTree[tree.name] = validTreeRule;


                if (tree.iconNode) {
                    this.UiModder.domClass.toggle(tree.iconNode, "w3-hide", !validTreeRule);
                }

                this.UiModder.domClass.toggle(tree.selectorNode, "invalidRule", !validTreeRule);

                if (validTreeRule) validTrees++;

            }



            if (this.rules.restrictToSingleTree === true) {
                valid = valid && validPerTree[this._selectedTree.name];
            } else {
                valid = valid && invalidTrees == 0;
            }

        }

        this.UiModder.domClass.toggle(this.rulesLabelContainer, "invalidRule", !basicRulesValid);

        return valid;
    }

    private _updateItemSelectionCountLabels() {


        let countTxt = ""
        let count = this.selectedItems.length;
        let OKbtn = null;
        let deselectBtn = null;

        if (this.dlg) {
            OKbtn = this.dlg.getButtonByName("submit");
            deselectBtn = this.dlg.getButtonByName("deselect");
        }

        if (count && this._enableMultiselect) {
            countTxt = "(" + count.toString() + ")";
        }

        let ruleCheck = this._checkRules();

        if (ruleCheck && this.closeOnSelect) {
            this.confirmSelection();
            return;
        }

        if (OKbtn) {
            //debugger;
            OKbtn.node.setAttribute("itemcount", countTxt);
            this.dlg.enableButton("submit", count > 0 && ruleCheck);

            //this.UiModder.domClass.toggle(OKbtn.node, "w3-disabled", !count || !ruleCheck );
            //this.UiModder.domClass.toggle(OKbtn.node, "primaryBG", count > 0);

        }

        if (deselectBtn) {
            deselectBtn.node.setAttribute("itemcount", countTxt);
            this.dlg.enableButton("deselect", count > 0);
            //this.UiModder.domClass.toggle(deselectBtn.node, "w3-disabled", !count);
            //this.UiModder.domClass.toggle(deselectBtn.node, "secondaryBG", count > 0);

        }

        if (!count) {

            if (deselectBtn) {
                deselectBtn.node.setAttribute("itemcount", countTxt);

            }
        } else {

        }


        if (this._enableMultiselect && deselectBtn) {

        }

        countTxt = this.stringFormat(this.translate("SelectEntityDlg__SelectionTabLabel"), count.toString());
        this.btnShowSelection.setAttribute("label", countTxt);
        this.UiModder.domAttr.set(this.btnShowSelection, "innerHTML", countTxt);

        this.UiModder.domClass.toggle(this.btnShowSelection, "w3-disabled", !count && this._showSelected != true);

    }

    _onClick_Unselect(evt?: MouseEvent) {

        if (this._enableMultiselect != true ) {
            return;
        }

        this.deselectAll();

        this.selectedItems = [];

        if (evt) {
            evt.stopPropagation();
        }

    }
    private _onClick_CreateNew(evt?: MouseEvent) {
        if (typeof (this.createNewCallback) == "function") {
            this.dlg._setCallbackAttr(lang.hitch(this, function () { /* nix */ }));
            this.dlg.destroyOnClose = false;
            this.dlg.close();

            aspect.after(this, "createNewCallback", lang.hitch(this, this._afterCreateNewCallback));

            this.createNewCallback();

        }
    }

    private _afterCreateNewCallback(result: any) {
        //console.debug("_afterCreateNewCallback", result);

        if (result) {

        } else {

        }
    }

    private _setupDlg() {
        if (this.dlg != null) {
            this.dlg.destroyOnClose = true;
            this.UiModder.domConstruct.place(this.mainContainer, this.domNode);
            this.dlg.close(-1);
            this.dlg = null;
        }

        this.dlg = new GenericDialog();
        this.dlg.secondaryButtonsAsMenu = false;
        this.dlg.allowVerticalGrowing(true);
        this.dlg._setHeaderAttr(this.dlgTitle);
        this.dlg._setCloseBtnAttr(false);
        this.dlg._setCancelBtnAttr(true);
        this.dlg._setOkBtnAttr(false);
        this.dlg._setTopCloseBtnAttr(true);
        this.dlg.addNodeToContent(this.mainContainer);
        this.dlg.addNodeToContent(this.rulesLabelContainer, "first");
        this.dlg.addNodeToContent(this.progressContainer, "bottom");
        this.dlg.addNodeToContent(this.previewSection, "bottom");

        this.UiModder.domClass.add(this.dlg.domNode, "selectEntityDialog"); // damit diverse Sonderstyles ziehen

        if (this.closeOnSelect != true) {
            this.dlg.addButton("submit", "OK", lang.hitch(this, this.confirmSelection), null, "primary", null, true, "first", false);

            let btn = this.dlg.getButtonByName("submit");
            if (this._enableMultiselect && btn) {

                this.UiModder.domClass.add(btn.node, "dlgSubmitCount");
                btn.node.setAttribute("itemcount", "");
            }
        }
        let spacer = null;
        if (this._enableMultiselect) {
            //if (!spacer) {
            //    this.dlg.addButton("-invisibleSpacerMS-", "s", null, null, "w3-disabled", null, false, "last");
            //    spacer = this.dlg.getButtonByName("-invisibleSpacerMS-");
            //    spacer.node.id = "spacer";
            //}

            this.dlg.addButton("deselect", "General_DeselectAll", lang.hitch(this, this.deselectAll), null, "w3-disabled dlgSubmitCount", null, false, "left last", false);
            let btn = this.dlg.getButtonByName("deselect");
            btn.node.setAttribute("itemcount", "");
            btn.node.id = "deselectAll";

            if (this._enableSelectAll) {
                this.dlg.addButton("selectAll", "SelectEntityDlg__SelectAll", lang.hitch(this, this._onClick_SelectAll), null, "primaryBG", null, false, "left first");
                let selectAllBtn = this.dlg.getButtonByName("selectAll");
                selectAllBtn.node.id = "selectAll";
            }
        }

        if (this.allowEmptyValue) {
            //if (!spacer) {
            //    this.dlg.addButton("-invisibleSpacerSN-", "s", null, null, "w3-disabled", null, false, "last");
            //    spacer = this.dlg.getButtonByName("-invisibleSpacerSN-");
            //    spacer.node.id = "spacer";
            //}

            this.dlg.addButton("selectNone", "SelectEntityDlg__SelectNone", lang.hitch(this, this._onClick_SelectNone), null, "", null, true, "left last");
            let btn = this.dlg.getButtonByName("selectNone");
            btn.node.id = "selectNone";
        }

        if (typeof (this.createNewCallback) === "function") {
            //if (!spacer) {
            //    this.dlg.addButton("-invisibleSpacerCN-", "s", null, null, "w3-disabled", null, false, "last");
            //    spacer = this.dlg.getButtonByName("-invisibleSpacerCN-");
            //    spacer.node.id = "spacer";
            //}

            this.dlg.addButton("createNew", "General_New", lang.hitch(this, this._onClick_CreateNew), null, "pL2", null, true, "left first");
            let btn = this.dlg.getButtonByName("createNew");
            btn.node.id = "createNew";
        }


        this.dlg._setCallbackAttr(lang.hitch(this, this._onDlgCallback));

        this.dlg.show();


    }

    private _onDlgCallback(result?: number | Function) {
        //console.log("selectEntityDlg _onDlgCallback", result);

        if (typeof (result) == "function") {

        } else if (result == 0) {
            // cancel / close
            this.emit("close");
        }

    }

    private confirmSelection() {
        if (typeof (this.callback) == "function") {

            this.callback(this.getSelectedValues(), this.selectedItems);
        }
        else {
            alert(this.id + " has no callbackfunction set!");
        }

    }

    /**
     *
     * @param initialSearchValue Initialer Suchwert beim Start, falls der gewählte Tree ein Suchfeld hat.
     * @param disableSearchValueOnStart Der Suchwert wird eingetragen, löst aber keinen Suchrequest aus. Nur sinnvoll für Konfigurationen mit lokaler Suche.
     */
    show(initialSearchValue?: string, disableSearchValueOnStart?: boolean): void {
        this._setupDlg();
        this.emit("show");

        if (this._selectedTree && !this._selectedTree.hideSearchInput) {
            this.searchInput.focus();

            if (disableSearchValueOnStart == true) {
                this.disableNode(this.searchInput);

                // aspect after deshalb, weil dort das input wieder reaktiviert wird!
                this._initialAspectAfterHandle = aspect.after(this, "_onGetRequestResult", lang.hitch(this, this._afterInitialResponse, initialSearchValue));

            }
            if (typeof (initialSearchValue) == "string") {
                this.searchInput.value = initialSearchValue;

                if (disableSearchValueOnStart === true) {
                    // die Suche wird mal nur hingeschrieben, aber nicht ausgelöst
                    // sinnvoll wenn eine Hintbox ihren gesamten Katalog laden soll
                    // die Suche passiert dann im AspectAfter lokal!

                } else {
                    this._searchValue = initialSearchValue;
                }
            }
        } else if (this._selectedTree._filterPanel) {
            this._selectedTree._filterPanel.focusFirstVisibleOption();
        }


        if (!this._isRequestActive && this._selectedTree._lastRequestResponse == null) {
            this.delaySearch(400);
        }

    }

    private _initialAspectAfterHandle: dojo.Handle = null;
    private _afterInitialResponse(searchValue) {
        this._initialAspectAfterHandle.remove();
        this._initialAspectAfterHandle = null;

        this.disableNode(this.searchInput, false);
        this.searchInput.value = searchValue ? searchValue : "";
        this._searchValue = searchValue;
        if (lang.isArray(this._selectedTree._lastRequestResponse)) {
            this._drawFromAnyResponseArray(this._selectedTree._lastRequestResponse);
        } else {

            // in dem Modus ist die erste Suche schon erledigt, aber wir müssen trotzdem nochmal suchen, weil wir vorher nicht wissen,
            // ob wir ein Array mit ALLEN Entities für lokale Suche bekommen oder ein packedResult mit einer Teilmenge.
            this.delaySearch(10);
        }
    }

    /**
     * Liefert die gewählten Einträge als String-Array.
     */
    getSelectedValues(): Array<string>{
        let values = [];
        let items = this.getSelectedItems();
        for (let item of items) {
            values.push(item.entry.value)
        }
        return values;
    }

    /**
     * Liefert die gewählten Einträge als simplifizierte Objekte (value und label)
     */
    getSelectedEntries(): Array<Types.Entry<T>> {
        let values: Array<Types.Entry<T>> = [];
        let items = this.getSelectedItems();

        for (let item of items) {
            values.push(item.entry);
        }

        return values;
    }
    /**
     * Liefert die gewählten Einträge Array mit den tatsächlich zugrundeliegenden Entities.
     * Achtung: Die Entities können bereits im Vorfeld simplifiziert worden sein und nicht den tatsächlichen Datenbank-Entities entsprechen.
     */
    getSelectedData(): Array<T> {
        let values: Array<T> = [];
        let items = this.getSelectedItems();

        for (let item of items) {
            if (item.entry.data) {
                values.push(item.entry.data);
            } else {
                return null;
            }
        }

        return values;
    }

    destroy(): void {
        if (this._requestHandle) {
            this._requestHandle.cancel();
        }
        super.destroy.apply(this, arguments as any);
    }


    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        // E2E: strukturelle Dialog-Elemente bekommen ein data-cy (die Ergebnis-Items/Werte NICHT –
        // die trifft der Test per selectValue über den Anzeige-Text im resultContainer).
        this.searchInput?.setAttribute("data-cy", "selectEntityDialog:searchInput");
        this.resultContainer?.setAttribute("data-cy", "selectEntityDialog:resultContainer");
        this.btnShowSelection?.setAttribute("data-cy", "selectEntityDialog:showSelection");

        // Methoden für Standby überschreiben mit eigenen Varianten
        this.StandbyStart = lang.hitch(this, this._StandbyStart);
        this.StandbyStop = lang.hitch(this, this._StandbyStop);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);

    }
}

export default mdsWidget(SelectEntityDialog);
